/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Sole_Super_Admin_WarningInputs */



/**
* | output |
* | --- |
* | "You are the only administrator. Nobody can reset your access if you lose your device, and you cannot reset your own. Invite a second administrator." |
*
* @param {Partner_Admin_Sole_Super_Admin_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_sole_super_admin_warning = /** @type {((inputs?: Partner_Admin_Sole_Super_Admin_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Sole_Super_Admin_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie sind der einzige Administrator. Wenn Sie Ihr Gerät verlieren, kann niemand Ihren Zugang zurücksetzen, und Sie können es nicht selbst tun. Laden Sie einen zweiten Administrator ein.")
	return /** @type {LocalizedString} */ ("You are the only administrator. Nobody can reset your access if you lose your device, and you cannot reset your own. Invite a second administrator.")
});